function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import PhabButton from '../phab/PhabButton';
import ObjectFitImage from './ObjectFitImage';
import CropSvg from '../iconography/icons/Crop';
import TrashSvg from '../iconography/icons/Trash';
import PhotoSvg from '../iconography/icons/Photo';
/**
 * The preview element action button
 */

var PreviewElementAction = function PreviewElementAction(_ref) {
  var iconType = _ref.iconType,
      onClick = _ref.onClick;

  if (!onClick) {
    return null;
  }

  return React.createElement("div", {
    className: "eds-image-uploader__preview-action eds-l-mar-all-2"
  }, React.createElement(PhabButton, {
    iconType: iconType,
    onClick: onClick
  }));
};
/**
 * The preview element actions bar with Crop, Remove & Replace buttons
 */


var PreviewElementActions = function PreviewElementActions(_ref2) {
  var onCrop = _ref2.onCrop,
      onRemove = _ref2.onRemove,
      onReplace = _ref2.onReplace,
      showActions = _ref2.showActions;

  if (!showActions) {
    return null;
  }

  return React.createElement("div", {
    className: "eds-image-uploader__preview-actions eds-fx--fade-in eds-fx--delay-1"
  }, React.createElement(PreviewElementAction, {
    iconType: React.createElement(CropSvg, null),
    onClick: onCrop
  }), React.createElement(PreviewElementAction, {
    iconType: React.createElement(TrashSvg, null),
    onClick: onRemove
  }), React.createElement(PreviewElementAction, {
    iconType: React.createElement(PhotoSvg, null),
    onClick: onReplace
  }));
};
/**
 * The element shown when the uploader is populated with an image
 */


var PreviewElement =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PreviewElement, _PureComponent);

  function PreviewElement(props) {
    var _this;

    _classCallCheck(this, PreviewElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PreviewElement).call(this, props));
    _this.state = {
      onTouch: null,
      onHover: false
    };
    return _this;
  }

  _createClass(PreviewElement, [{
    key: "_handleTouch",
    value: function _handleTouch() {
      this.setState(function (_ref3) {
        var prevOnTouch = _ref3.onTouch;
        return {
          onTouch: !prevOnTouch
        };
      });
    }
  }, {
    key: "_handleMouseOver",
    value: function _handleMouseOver() {
      this.setState({
        onHover: true
      });
    }
  }, {
    key: "_handleMouseLeave",
    value: function _handleMouseLeave() {
      this.setState({
        onHover: false
      });
    }
  }, {
    key: "_showActions",
    value: function _showActions() {
      // User should only be able to see preview action buttons by
      // 1) Touch event on mobile browsers
      // 2) Hover event on desktop browsers
      var showActions;

      if (this.state.onTouch !== null) {
        showActions = this.state.onTouch;
      } else {
        showActions = this.state.onHover;
      }

      return showActions;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          altText = _this$props.altText,
          onRemove = _this$props.onRemove,
          onReplace = _this$props.onReplace,
          onCrop = _this$props.onCrop;

      var showActions = this._showActions();

      var previewBackgroundClassName = classNames({
        'eds-image-uploader__preview-action-background-hidden': !showActions
      }, 'eds-image-uploader__preview-action-background', 'eds-fx--fade-in');
      return React.createElement("div", {
        className: "eds-image-uploader__preview",
        onMouseOver: this._handleMouseOver.bind(this),
        onMouseLeave: this._handleMouseLeave.bind(this),
        onFocus: noop(),
        "data-spec": "image-uploader-preview"
      }, React.createElement(ObjectFitImage, {
        imageSrc: url,
        imageAlt: altText,
        imageClassName: "eds-image-uploader__preview-image",
        "data-spec": "image-uploader-preview-image"
      }), React.createElement("div", {
        className: previewBackgroundClassName,
        onTouchStart: this._handleTouch.bind(this)
      }), React.createElement(PreviewElementActions, {
        onRemove: onRemove,
        onReplace: onReplace,
        onCrop: onCrop,
        showActions: this._showActions()
      }));
    }
  }]);

  return PreviewElement;
}(PureComponent);

_defineProperty(PreviewElement, "propTypes", {
  /**
   * Image url of the image for preview.
   */
  url: PropTypes.string,

  /**
   * Image alt text for the image element.
   */
  altText: EBPropTypes.translation,

  /**
   * Function that's invoked when user clicks on crop button.
   */
  onCrop: PropTypes.func,

  /**
   * Function that's invoked when user clicks on trash button.
   */
  onRemove: PropTypes.func,

  /**
   * Function that's invoked when user clicks on image button.
   */
  onReplace: PropTypes.func
});

export { PreviewElement as default };